import React from "react";

export default function Page({
  title,
  children,
  padding,
  pageClassName = "page-content",
  backgroundColour = "white",
  extraStyles,
}) {
  document.title = title;

  return (
    <div
      id="page"
      className={pageClassName}
      style={{
        ...(padding ? { padding } : {}),
        backgroundColor: backgroundColour,
        ...extraStyles,
      }}
    >
      {children}
    </div>
  );
}
